// composables/useNovaPoshtaMock.js
import { ref } from "vue";

// Мок-дані
const CITIES = [
  { ref: "c-kyiv", label: "Київ" },
  { ref: "c-lviv", label: "Львів" },
  { ref: "c-odesa", label: "Одеса" },
  { ref: "c-kharkiv", label: "Харків" },
  { ref: "c-dnipro", label: "Дніпро" },
];

const WAREHOUSES = {
  "c-kyiv": [
    {
      ref: "w-k-001",
      type: "branch",
      label: "Відділення №1, вул. Хрещатик, 1",
    },
    {
      ref: "w-k-002",
      type: "branch",
      label: "Відділення №12, вул. Васильківська, 10",
    },
    { ref: "w-k-101", type: "postamat", label: "Поштомат №101, ТРЦ Гулівер" },
  ],
  "c-lviv": [
    {
      ref: "w-l-003",
      type: "branch",
      label: "Відділення №3, просп. Свободи, 15",
    },
    { ref: "w-l-102", type: "postamat", label: "Поштомат №102, ТРЦ Форум" },
  ],
  "c-odesa": [
    {
      ref: "w-o-004",
      type: "branch",
      label: "Відділення №4, вул. Дерibasівська, 5",
    },
  ],
  "c-kharkiv": [
    {
      ref: "w-h-005",
      type: "branch",
      label: "Відділення №5, просп. Науки, 25",
    },
  ],
  "c-dnipro": [
    {
      ref: "w-d-006",
      type: "branch",
      label: "Відділення №6, вул. Центральна, 3",
    },
  ],
};

function delay(ms = 300) {
  return new Promise((r) => setTimeout(r, ms));
}

export function useNovaPoshtaMock() {
  const cities = ref([]);
  const warehouses = ref([]);

  async function searchCities(q = "") {
    await delay();
    const s = q.trim().toLowerCase();
    cities.value = !s
      ? CITIES.slice(0, 10)
      : CITIES.filter((c) => c.label.toLowerCase().includes(s)).slice(0, 10);
    return cities.value;
  }

  async function searchWarehouses(cityRef, q = "", kind = "all") {
    await delay();
    const all = WAREHOUSES[cityRef] || [];
    const byKind = kind === "all" ? all : all.filter((w) => w.type === kind);
    const s = q.trim().toLowerCase();
    warehouses.value = !s
      ? byKind.slice(0, 20)
      : byKind.filter((w) => w.label.toLowerCase().includes(s)).slice(0, 20);
    return warehouses.value;
  }

  return { cities, warehouses, searchCities, searchWarehouses };
}
